/**
 * Created by Carsten Bühler
 * User: CBuehler on 16.12.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import Dropzone from 'external/react-dropzone';
import UploadWebApi from '../webapi/UploadWebApi';
import ProgressBar from './ProgressBar';
import { Button, Card, Col, Row } from 'external/react-bootstrap';
import { AppContext, detectIE } from 'plugin/liferay-widgets-react-web';
import '../css/upload.scss';

// eslint-disable-next-line react/prop-types
const UploadMediaEntry = ({ entry, onClickDelete }) => {
    const title = entry.file.src.name;

    if (entry.state.status === 'fail') {
        return (
            <Col lg={3} md={4} sm={6} xs={12}>
                <div>Upload fehlgeschlagen</div>
            </Col>
        );
    }

    return (
        <Col lg={4} md={4} sm={6} xs={12}>
            <Card className="upload-preview-card">
                <Card.Header className="d-flex justify-content-end p-1">
                    <Button
                        variant="outline-danger"
                        onClick={onClickDelete}
                        size="sm"
                        pullRight
                    >
                        X
                    </Button>
                </Card.Header>
                <Card.Img
                    variant="top"
                    as={detectIE() ? 'img' : 'object'}
                    data={entry.file.src.preview}
                    src={entry.file.src.preview}
                    type={entry.file.src.type}
                    title={title}
                    alt={title}
                />
                <Card.Body>
                    <Card.Text>
                        {title}
                    </Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
};

class Upload extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            tmpEntries: []
        };
    }

    componentWillUnmount(){
        let tmpEntries = this.state.tmpEntries || [];

        tmpEntries.forEach(e => {
            this.onClickDelete(e, false);
        });
    }

    onDrop(acceptedFiles){
        //const { uploadStatus } = this.props;
        let uplds = []; // upload promises
        let uploads = []; // valid URIs for upload

        acceptedFiles.forEach((f, i) => {
            this.addUpload(f, i, uploads);
        });

        if(this.props.uploadObserver) {
            if(uploads.length > 0) {
                this.props.uploadObserver(true);
            }
        }

        uploads.forEach(file => {
            uplds.push(
                UploadWebApi.uploadTemp(file.src, { onProgress: this.onProgress.bind(this, file.k) }).then(
                    (fileEntry) => {
                        this.appendToState(file, file.src.name, fileEntry.fileName, { status: 'success', error: null });
                        this.props.uploadObserver && this.props.uploadObserver(false);
                    },
                    (error) => {
                        this.appendToState(file, file.src.name, undefined, { status: 'fail', error: error });
                        this.props.uploadObserver && this.props.uploadObserver(false);
                    })
            );
        });
    }

    onProgress(upload, progress){
        const p = (progress.loaded / progress.total) * 100;

        let uploads = this.state.uploads || [];
        uploads.forEach(u => {
            if (u.k == upload) {
                u.progress = p;
            }
        });

        this.setState({
            uploads
        });
    }

    addUpload(f, i, uploads){
        if (f instanceof File || this.isLocalURI(f)) {
            uploads.push({ k: i, src: f });
            this.setState({
                uploads
            });
        } else if (!f) {
            console.debug('No value for file: ' + i);
        } else {
            console.warn('No local uri! File ' + i + ' : ' + f);
        }
    }

    isLocalURI(uri){
        return uri && uri.indexOf && (
            (uri.indexOf('file:/') > -1) ||
            (uri.indexOf('/') === 0) ||
            (uri.indexOf('blob:') === 0) ||
            (uri.indexOf('moz-filedata:') === 0) ||
            (uri.indexOf('content://') > -1) ||
            (uri.indexOf('///') > -1)
        );
    }

    appendToState(file, fileName, tmpFileName, state){
        let tmpEntries = this.state.tmpEntries || [];
        let uploads = this.state.uploads || [];

        let found = false;
        tmpEntries = tmpEntries.map(entry => {
            if (entry.fileName === fileName) {
                found = true;
                this.onClickDelete(entry);
                return {
                    fileName,
                    tmpFileName,
                    file,
                    state
                };
            } else {
                return entry;
            }
        });

        if (!found) {
            tmpEntries.push({
                fileName,
                tmpFileName,
                file,
                state
            });
        }

        this.onChange(tmpEntries);

        this.setState({
            tmpEntries,
            uploads: uploads.filter(u => {
                return u != file;
            })
        });
    }

    onChange(tmpEntries){
        this.props.onChange(JSON.stringify(tmpEntries.map(e => {
            let newE = {
                ...e
            };
            delete newE.file;

            return newE;
        })));
    }

    onClickDelete(entry, propagateError = true){
        this.deleteEntry(entry.tmpFileName, entry, propagateError);
    }

    deleteEntry(tmpFileName, entry, propagateError){
        let options = {
            afterSuccess: (a) => {
                let tmpEntries = this.state.tmpEntries || [];
                const newTmpEntries = tmpEntries.filter((e) => {
                    return e.tmpFileName != tmpFileName;
                });
                this.onChange(newTmpEntries);
                this.setState({
                    tmpEntries: newTmpEntries
                });

            }
        };

        if (propagateError) {
            options = {
                ...options,
                afterError: (e) => {
                    console.error('Error delete Entry', e);
                    this.appendToState(entry, entry.file.src.name, undefined, { status: 'fail', error: e });
                }
            };
        }
        AppContext.getDispatcher().dispatchAsyncOperation('DELETE_TEMP_FILE', UploadWebApi.deleteTemp, { tmpFileName }, options);

    }

    render(){

        const { InputElement, required, accept = 'image/*', acceptedImages, acceptedVideos, acceptedDocuments } = this.props;
        const uploads = this.state.uploads || [];
        //      const progress = this.state.progress;
        //      const isUploading = uploads && uploads.length > 0;

        return (
            <div className="form-group row py-4">
                <Col sm={3}>
                    <label className="control-label">
                        Dateien{required ? '*' : ''}
                    </label>
                </Col>
                <Col sm={9}>
                    {
                        InputElement &&
                        <input name="tmpEntries"
                               type="hidden"
                               onChange={this.props.onChange.bind(this)}
                               value={JSON.stringify(this.state.tmpEntries.map(e => {
                                   let newE = {
                                       ...e
                                   };
                                   delete newE.file;

                                   return newE;
                               }))}/>
                    }

                    <Dropzone
                        ref={(node) => {this.dropzone = node;}}
                        onDrop={this.onDrop.bind(this)}
                        accept={accept}
                        className="upload-dropzone"
                        multiple={true}
                    >
                        <strong>
                            Bitte ziehen Sie eine oder mehrere Dateien in die Fläche.
                            Oder klicken Sie auf die Fläche und wählen eine oder mehrere Dateien im Dialog aus.
                        </strong>
                        {
                            (acceptedImages || acceptedVideos || acceptedDocuments) &&
                            <React.Fragment>
                                <strong className="w-100 pt-2">
                                    Folgende Dateitypen werden akzeptiert:
                                </strong>
                                {
                                    acceptedImages &&
                                    <div className="w-100">
                                        <strong>Bilder</strong> ({acceptedImages})
                                    </div>
                                }
                                {
                                    acceptedVideos &&
                                    <div className="w-100">
                                        <strong>Videos</strong> ({acceptedVideos})
                                    </div>
                                }
                                {
                                    acceptedDocuments &&
                                    <div className="w-100">
                                        <strong>Dokumente</strong> ({acceptedDocuments})
                                    </div>
                                }
                            </React.Fragment>
                        }

                    </Dropzone>
                    {
                        uploads && uploads.length > 0 &&
                        uploads.map(upload => {
                            return (
                                <div key={upload.src.name}>
                                    Upload ({upload.src.name}):&nbsp;<ProgressBar percentage={upload.progress}/>
                                </div>
                            );
                        })

                    }
                    <br/>
                    {
                        this.state.tmpEntries.length > 0 &&
                        <Row>
                            {
                                this.state.tmpEntries.map((entry) => (
                                    <UploadMediaEntry
                                        key={entry.file.src.name}
                                        entry={entry}
                                        onClickDelete={this.onClickDelete.bind(this, entry)}
                                    />
                                ))
                            }
                        </Row>
                    }
                </Col>
            </div>
        );
    }
}

Upload.propTypes = {
    onChange: PropTypes.func,
    onClickDelete: PropTypes.func,
    entry: PropTypes.object,
    InputElement: PropTypes.func,
    required: PropTypes.object,
    accept: PropTypes.string,
    acceptedImages: PropTypes.string,
    acceptedVideos: PropTypes.string,
    acceptedDocuments: PropTypes.string,
    uploadObserver: PropTypes.func,
};

export default Upload;



// WEBPACK FOOTER //
// ./js/components/Upload.jsx